import { gql } from 'apollo-boost';

export const updateOrganizations = gql`
    mutation UpdateOrganizations($input: [GdUpdateOrganizationInput!]!) {
        reqId: getReqId
        updateOrganizations(input: $input) {
            updatedAds {
                id
            }
            validationResult {
                errors {
                    code
                    params
                    path
                }
                warnings {
                    code
                    params
                    path
                }
            }
        }
    }
`;
